<template>
  <div class="nettdoc-swelling">
    <SectionHeader 
      text="I have a swelling" 
      img="illu-card-beschwerden-swelling" 
      alt="swollen hand" 
      :collapsable="true" 
      v-on:collapse="collapsed = !collapsed"
      :complete="store.swellingDetails.submitted"
    />

    <template v-if="collapsed">
      <SectionHeader text="Which bodypart is swollen?" :dark="true" :required="true" />
      <Bodyparts 
        :model="store.swellingDetails.location"
        v-on:action="value => store.addSwellingDetails('location', value)"
      />

      <SectionHeader text="coldPastWeeks" :dark="true" :required="false" />
      <YesNo
        :model="store.swellingDetails.coldPastWeeks"
        v-on:action="value => store.addSwellingDetails('coldPastWeeks', value)"
      />

      <SectionHeader text="teethHurt" :dark="true" :required="false" />
      <YesNo
        :model="store.swellingDetails.teethHurt"
        v-on:action="value => store.addSwellingDetails('teethHurt', value)"
      />

      <SectionHeader text="developedSlowly" :dark="true" :required="false" />
      <YesNo
        :model="store.swellingDetails.developedSlowly"
        v-on:action="value => store.addSwellingDetails('developedSlowly', value)"
      />

      <SectionHeader text="developedSuddenly" :dark="true" :required="false" />
      <YesNo
        :model="store.swellingDetails.developedSuddenly"
        v-on:action="value => store.addSwellingDetails('developedSuddenly', value)"
      />

      <SectionHeader text="hurts" :dark="true" :required="false" />
      <YesNo
        :model="store.swellingDetails.hurts"
        v-on:action="value => store.addSwellingDetails('hurts', value)"
      />

      <template v-if="store.swellingDetails.hurts === 'yes'">
        <SectionHeader text="hurtIsGetting" :dark="true" :required="false" />
        <Dropdown
          label="please choose"
          :data="['more', 'less']"
          :choice="store.swellingDetails.hurtIsGetting"
          v-on:action="value => store.addSwellingDetails('hurtIsGetting', value)"
        />
      </template>

      <SectionHeader text="redness" :dark="true" :required="false" />
      <YesNo
        :model="store.swellingDetails.redness"
        v-on:action="value => store.addSwellingDetails('redness', value)"
      />

      <template v-if="store.swellingDetails.redness === 'yes'">
        <SectionHeader text="rednessGetting" :dark="true" :required="false" />
        <Dropdown
          label="please choose"
          :data="['more', 'less']"
          :choice="store.swellingDetails.rednessGetting"
          v-on:action="value => store.addSwellingDetails('rednessGetting', value)"
        />
      </template>

      <SectionHeader text="strongestSwellingTime" :dark="true" :required="false" />
      <Dropdown
        label="please choose"
        :data="['At night', 'In the morning', 'During the day / at noon', 'In the evening', 'Always', 'The Swelling does not depend on the time of the day']"
        :choice="store.swellingDetails.strongestSwellingTime"
        v-on:action="value => store.addSwellingDetails('strongestSwellingTime', value)"
      />

      <SectionHeader text="incidentShortlyBeforeSwelling" :dark="true" :required="false" />
      <Dropdown
        label="please choose"
        :data="['Bite by an insect', 'Injury', 'accident', 'surger', 'A lot of physical activity']"
        :choice="store.swellingDetails.incidentShortlyBeforeSwelling"
        v-on:action="value => store.addSwellingDetails('incidentShortlyBeforeSwelling', value)"
      />

      <SectionHeader text="otherDiseases" :dark="true" :required="false" />
      <Dropdown
        label="please choose"
        :data="['Cardio-vascular disorder', 'Disease of the liver', 'Disease of the kidneys']"
        :choice="store.swellingDetails.otherDiseases"
        v-on:action="value => store.addSwellingDetails('otherDiseases', value)"
      />

      <Button :text="edit ? 'Update' : 'Submit'" v-on:action="submit" :active="store.swellingDetailsComplete" />
    </template>
  </div>
</template>

<script>
import { observer } from "mobx-vue";

import SectionHeader from "../SectionHeader";
import YesNo from "../YesNo";
import Button from "../Button";
import Dropdown from "../Dropdown";
import Bodyparts from '../Bodyparts'
export default observer({
  name: "Swelling",
  data() {
    return {
      collapsed: true
    };
  },
  props: {
    store: Object,
    edit: Boolean
  },
  components: {
    SectionHeader, YesNo, Button, Dropdown, Bodyparts
  },
  methods: {
    submit: function() {
      this.store.swellingDetails.submitted = true
      localStorage.setItem(
        "swellingDetails",
        JSON.stringify(this.store.swellingDetails)
      )
      if (this.edit) {
        this.$emit('close')
      } else {
        this.collapsed = !this.collapsed
        window.scrollTo(0,0)
      }
    }
  }
})
</script>

<style>

</style>